(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["print-on-anything"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const openItem = event.target.closest('.print-anything__item');
    document.querySelectorAll('.print-anything__item.is-open').forEach((item) => {
      if (item !== openItem) {
        item.classList.remove('is-open');
        item.setAttribute('aria-expanded', 'false');
      }
    });

    if (openItem && openItem.hasAttribute('aria-expanded')) {
      const isOpen = openItem.classList.toggle('is-open');
      openItem.setAttribute('aria-expanded', String(isOpen));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.print-anything__item.is-open').forEach((item) => {
        item.classList.remove('is-open');
        item.setAttribute('aria-expanded', 'false');
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
